import { render, staticRenderFns } from "./Category.html?vue&type=template&id=3e650ff2&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.scss?vue&type=style&index=0&id=3e650ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e650ff2",
  null
  
)

export default component.exports